module.exports = __webpack_public_path__ + "img/grid.857cb790.png";